import React from 'react'
import Main from './MaintitleDesc.js'
import EventCard from "./EventsCard"
import Slider from "./CarouselWrapper"
export default function Event(props) {
    return (
        <div>
            <Main {...props} />
            {props.cards ? <Slider data={props.cards} child={EventCard } />:null} 
        </div>
    )
}


const howToEn = [
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-1.png",
      "title": "Open AirAsia MOVE mobile app",
      "subtitle": "Step 1"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-2.png",
      "title": "Tap \"Flights\"",
      "subtitle": "Step 2"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-3.png",
      "title": "Select your travel dates",
      "subtitle": "Step 3"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-4.png",
      "title": "Choose a flight",
      "subtitle": "Step 4"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-5.png",
      "title": "Enter guest details",
      "subtitle": "Step 5"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-6.png",
      "title": "Enter payment details",
      "subtitle": "Step 6"
    },
    {
      "image": "https://static.airasia.com/seo/images/others/how-to-en-7.png",
      "title": "Confirm and press \"Purchase\"",
      "subtitle": "Step 7"
    }
  ]